var map = {
	"./desktop/b2b.png": 7532,
	"./desktop/content.png": 1050,
	"./desktop/digital.png": 4949,
	"./desktop/experience.png": 4538,
	"./desktop/influencer.png": 5060,
	"./desktop/retail.png": 7423,
	"./mobile/b2b.png": 947,
	"./mobile/content.png": 543,
	"./mobile/digital.png": 3348,
	"./mobile/experience.png": 6308,
	"./mobile/influencer.png": 5015,
	"./mobile/retail.png": 7344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9210;